import { API_URL } from "./apiBase";
import { SearchCriteria, SearchUser } from "@models/search";

export const getProject = async (
  project_id: string,
  accessToken: string | null
) => {
  return fetch(`${API_URL}/projects/${project_id}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  }).then((res) => res.json());
};

export async function getProjectCards(accessToken: string | null) {
  return fetch(`${API_URL}/projects/`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  }).then((res) => res.json());
}

export const searchBidders = async (
  criteria: SearchCriteria,
  accessToken: string | null
) => {
  return fetch(`${API_URL}/search/`, {
    method: "POST",
    body: JSON.stringify(criteria),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
  }).then((res) => res.json());
};

export const lookupBidders = async (
  criteria: SearchUser,
  accessToken: string | null
) => {
  return fetch(`${API_URL}/search/lookup`, {
    method: "POST",
    body: JSON.stringify(criteria),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
  }).then((res) => res.json());
};

export const InviteBidder = async (
  target_project: string,
  target_company: string,
  accessToken: string | null
) => {
  return fetch(`${API_URL}/projects/${target_project}/invite`, {
    method: "POST",
    body: JSON.stringify({ company_id: target_company }),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
  }).then((res) => res.json());
};

export const InviteBidderUser = async (
  target_project: string,
  email: string,
  accessToken: string | null
) => {
  return fetch(`${API_URL}/projects/${target_project}/invite_user`, {
    method: "POST",
    body: JSON.stringify({ user_email: email, project_id: target_project }),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
  }).then((res) => res.json());
};
